parcelRequire = (function (e, r, t, n) {
  var i,
    o = "function" == typeof parcelRequire && parcelRequire,
    u = "function" == typeof require && require;
  function f(t, n) {
    if (!r[t]) {
      if (!e[t]) {
        var i = "function" == typeof parcelRequire && parcelRequire;
        if (!n && i) return i(t, !0);
        if (o) return o(t, !0);
        if (u && "string" == typeof t) return u(t);
        var c = new Error("Cannot find module '" + t + "'");
        throw ((c.code = "MODULE_NOT_FOUND"), c);
      }
      (p.resolve = function (r) {
        return e[t][1][r] || r;
      }),
        (p.cache = {});
      var l = (r[t] = new f.Module(t));
      e[t][0].call(l.exports, p, l, l.exports, this);
    }
    return r[t].exports;
    function p(e) {
      return f(p.resolve(e));
    }
  }
  (f.isParcelRequire = !0),
    (f.Module = function (e) {
      (this.id = e), (this.bundle = f), (this.exports = {});
    }),
    (f.modules = e),
    (f.cache = r),
    (f.parent = o),
    (f.register = function (r, t) {
      e[r] = [
        function (e, r) {
          r.exports = t;
        },
        {},
      ];
    });
  for (var c = 0; c < t.length; c++)
    try {
      f(t[c]);
    } catch (e) {
      i || (i = e);
    }
  if (t.length) {
    var l = f(t[t.length - 1]);
    "object" == typeof exports && "undefined" != typeof module
      ? (module.exports = l)
      : "function" == typeof define && define.amd
      ? define(function () {
          return l;
        })
      : n && (this[n] = l);
  }
  if (((parcelRequire = f), i)) throw i;
  return f;
})(
  {
    Focm: [
      function (require, module, exports) {
        function t(e) {
          return (t =
            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
              ? function (t) {
                  return typeof t;
                }
              : function (t) {
                  return t &&
                    "function" == typeof Symbol &&
                    t.constructor === Symbol &&
                    t !== Symbol.prototype
                    ? "symbol"
                    : typeof t;
                })(e);
        }
        function e(t) {
          return o(t) || n(t) || c(t) || r();
        }
        function r() {
          throw new TypeError(
            "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
          );
        }
        function n(t) {
          if (
            ("undefined" != typeof Symbol && null != t[Symbol.iterator]) ||
            null != t["@@iterator"]
          )
            return Array.from(t);
        }
        function o(t) {
          if (Array.isArray(t)) return a(t);
        }
        function i(t, e) {
          var r =
            ("undefined" != typeof Symbol && t[Symbol.iterator]) ||
            t["@@iterator"];
          if (!r) {
            if (
              Array.isArray(t) ||
              (r = c(t)) ||
              (e && t && "number" == typeof t.length)
            ) {
              r && (t = r);
              var n = 0,
                o = function () {};
              return {
                s: o,
                n: function () {
                  return n >= t.length
                    ? { done: !0 }
                    : { done: !1, value: t[n++] };
                },
                e: function (t) {
                  throw t;
                },
                f: o,
              };
            }
            throw new TypeError(
              "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
            );
          }
          var i,
            a = !0,
            u = !1;
          return {
            s: function () {
              r = r.call(t);
            },
            n: function () {
              var t = r.next();
              return (a = t.done), t;
            },
            e: function (t) {
              (u = !0), (i = t);
            },
            f: function () {
              try {
                a || null == r.return || r.return();
              } finally {
                if (u) throw i;
              }
            },
          };
        }
        function c(t, e) {
          if (t) {
            if ("string" == typeof t) return a(t, e);
            var r = Object.prototype.toString.call(t).slice(8, -1);
            return (
              "Object" === r && t.constructor && (r = t.constructor.name),
              "Map" === r || "Set" === r
                ? Array.from(t)
                : "Arguments" === r ||
                  /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)
                ? a(t, e)
                : void 0
            );
          }
        }
        function a(t, e) {
          (null == e || e > t.length) && (e = t.length);
          for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
          return n;
        }
        function u() {
          "use strict";
          u = function () {
            return e;
          };
          var e = {},
            r = Object.prototype,
            n = r.hasOwnProperty,
            o =
              Object.defineProperty ||
              function (t, e, r) {
                t[e] = r.value;
              },
            i = "function" == typeof Symbol ? Symbol : {},
            c = i.iterator || "@@iterator",
            a = i.asyncIterator || "@@asyncIterator",
            l = i.toStringTag || "@@toStringTag";
          function s(t, e, r) {
            return (
              Object.defineProperty(t, e, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0,
              }),
              t[e]
            );
          }
          try {
            s({}, "");
          } catch (O) {
            s = function (t, e, r) {
              return (t[e] = r);
            };
          }
          function f(t, e, r, n) {
            var i = e && e.prototype instanceof p ? e : p,
              c = Object.create(i.prototype),
              a = new j(n || []);
            return o(c, "_invoke", { value: E(t, r, a) }), c;
          }
          function d(t, e, r) {
            try {
              return { type: "normal", arg: t.call(e, r) };
            } catch (O) {
              return { type: "throw", arg: O };
            }
          }
          e.wrap = f;
          var h = {};
          function p() {}
          function y() {}
          function v() {}
          var m = {};
          s(m, c, function () {
            return this;
          });
          var g = Object.getPrototypeOf,
            w = g && g(g(k([])));
          w && w !== r && n.call(w, c) && (m = w);
          var b = (v.prototype = p.prototype = Object.create(m));
          function L(t) {
            ["next", "throw", "return"].forEach(function (e) {
              s(t, e, function (t) {
                return this._invoke(e, t);
              });
            });
          }
          function S(e, r) {
            var i;
            o(this, "_invoke", {
              value: function (o, c) {
                function a() {
                  return new r(function (i, a) {
                    !(function o(i, c, a, u) {
                      var l = d(e[i], e, c);
                      if ("throw" !== l.type) {
                        var s = l.arg,
                          f = s.value;
                        return f && "object" == t(f) && n.call(f, "__await")
                          ? r.resolve(f.__await).then(
                              function (t) {
                                o("next", t, a, u);
                              },
                              function (t) {
                                o("throw", t, a, u);
                              }
                            )
                          : r.resolve(f).then(
                              function (t) {
                                (s.value = t), a(s);
                              },
                              function (t) {
                                return o("throw", t, a, u);
                              }
                            );
                      }
                      u(l.arg);
                    })(o, c, i, a);
                  });
                }
                return (i = i ? i.then(a, a) : a());
              },
            });
          }
          function E(t, e, r) {
            var n = "suspendedStart";
            return function (o, i) {
              if ("executing" === n)
                throw new Error("Generator is already running");
              if ("completed" === n) {
                if ("throw" === o) throw i;
                return A();
              }
              for (r.method = o, r.arg = i; ; ) {
                var c = r.delegate;
                if (c) {
                  var a = x(c, r);
                  if (a) {
                    if (a === h) continue;
                    return a;
                  }
                }
                if ("next" === r.method) r.sent = r._sent = r.arg;
                else if ("throw" === r.method) {
                  if ("suspendedStart" === n) throw ((n = "completed"), r.arg);
                  r.dispatchException(r.arg);
                } else "return" === r.method && r.abrupt("return", r.arg);
                n = "executing";
                var u = d(t, e, r);
                if ("normal" === u.type) {
                  if (
                    ((n = r.done ? "completed" : "suspendedYield"), u.arg === h)
                  )
                    continue;
                  return { value: u.arg, done: r.done };
                }
                "throw" === u.type &&
                  ((n = "completed"), (r.method = "throw"), (r.arg = u.arg));
              }
            };
          }
          function x(t, e) {
            var r = e.method,
              n = t.iterator[r];
            if (void 0 === n)
              return (
                (e.delegate = null),
                ("throw" === r &&
                  t.iterator.return &&
                  ((e.method = "return"),
                  (e.arg = void 0),
                  x(t, e),
                  "throw" === e.method)) ||
                  ("return" !== r &&
                    ((e.method = "throw"),
                    (e.arg = new TypeError(
                      "The iterator does not provide a '" + r + "' method"
                    )))),
                h
              );
            var o = d(n, t.iterator, e.arg);
            if ("throw" === o.type)
              return (
                (e.method = "throw"), (e.arg = o.arg), (e.delegate = null), h
              );
            var i = o.arg;
            return i
              ? i.done
                ? ((e[t.resultName] = i.value),
                  (e.next = t.nextLoc),
                  "return" !== e.method &&
                    ((e.method = "next"), (e.arg = void 0)),
                  (e.delegate = null),
                  h)
                : i
              : ((e.method = "throw"),
                (e.arg = new TypeError("iterator result is not an object")),
                (e.delegate = null),
                h);
          }
          function _(t) {
            var e = { tryLoc: t[0] };
            1 in t && (e.catchLoc = t[1]),
              2 in t && ((e.finallyLoc = t[2]), (e.afterLoc = t[3])),
              this.tryEntries.push(e);
          }
          function q(t) {
            var e = t.completion || {};
            (e.type = "normal"), delete e.arg, (t.completion = e);
          }
          function j(t) {
            (this.tryEntries = [{ tryLoc: "root" }]),
              t.forEach(_, this),
              this.reset(!0);
          }
          function k(t) {
            if (t) {
              var e = t[c];
              if (e) return e.call(t);
              if ("function" == typeof t.next) return t;
              if (!isNaN(t.length)) {
                var r = -1,
                  o = function e() {
                    for (; ++r < t.length; )
                      if (n.call(t, r))
                        return (e.value = t[r]), (e.done = !1), e;
                    return (e.value = void 0), (e.done = !0), e;
                  };
                return (o.next = o);
              }
            }
            return { next: A };
          }
          function A() {
            return { value: void 0, done: !0 };
          }
          return (
            (y.prototype = v),
            o(b, "constructor", { value: v, configurable: !0 }),
            o(v, "constructor", { value: y, configurable: !0 }),
            (y.displayName = s(v, l, "GeneratorFunction")),
            (e.isGeneratorFunction = function (t) {
              var e = "function" == typeof t && t.constructor;
              return (
                !!e &&
                (e === y || "GeneratorFunction" === (e.displayName || e.name))
              );
            }),
            (e.mark = function (t) {
              return (
                Object.setPrototypeOf
                  ? Object.setPrototypeOf(t, v)
                  : ((t.__proto__ = v), s(t, l, "GeneratorFunction")),
                (t.prototype = Object.create(b)),
                t
              );
            }),
            (e.awrap = function (t) {
              return { __await: t };
            }),
            L(S.prototype),
            s(S.prototype, a, function () {
              return this;
            }),
            (e.AsyncIterator = S),
            (e.async = function (t, r, n, o, i) {
              void 0 === i && (i = Promise);
              var c = new S(f(t, r, n, o), i);
              return e.isGeneratorFunction(r)
                ? c
                : c.next().then(function (t) {
                    return t.done ? t.value : c.next();
                  });
            }),
            L(b),
            s(b, l, "Generator"),
            s(b, c, function () {
              return this;
            }),
            s(b, "toString", function () {
              return "[object Generator]";
            }),
            (e.keys = function (t) {
              var e = Object(t),
                r = [];
              for (var n in e) r.push(n);
              return (
                r.reverse(),
                function t() {
                  for (; r.length; ) {
                    var n = r.pop();
                    if (n in e) return (t.value = n), (t.done = !1), t;
                  }
                  return (t.done = !0), t;
                }
              );
            }),
            (e.values = k),
            (j.prototype = {
              constructor: j,
              reset: function (t) {
                if (
                  ((this.prev = 0),
                  (this.next = 0),
                  (this.sent = this._sent = void 0),
                  (this.done = !1),
                  (this.delegate = null),
                  (this.method = "next"),
                  (this.arg = void 0),
                  this.tryEntries.forEach(q),
                  !t)
                )
                  for (var e in this)
                    "t" === e.charAt(0) &&
                      n.call(this, e) &&
                      !isNaN(+e.slice(1)) &&
                      (this[e] = void 0);
              },
              stop: function () {
                this.done = !0;
                var t = this.tryEntries[0].completion;
                if ("throw" === t.type) throw t.arg;
                return this.rval;
              },
              dispatchException: function (t) {
                if (this.done) throw t;
                var e = this;
                function r(r, n) {
                  return (
                    (c.type = "throw"),
                    (c.arg = t),
                    (e.next = r),
                    n && ((e.method = "next"), (e.arg = void 0)),
                    !!n
                  );
                }
                for (var o = this.tryEntries.length - 1; o >= 0; --o) {
                  var i = this.tryEntries[o],
                    c = i.completion;
                  if ("root" === i.tryLoc) return r("end");
                  if (i.tryLoc <= this.prev) {
                    var a = n.call(i, "catchLoc"),
                      u = n.call(i, "finallyLoc");
                    if (a && u) {
                      if (this.prev < i.catchLoc) return r(i.catchLoc, !0);
                      if (this.prev < i.finallyLoc) return r(i.finallyLoc);
                    } else if (a) {
                      if (this.prev < i.catchLoc) return r(i.catchLoc, !0);
                    } else {
                      if (!u)
                        throw new Error(
                          "try statement without catch or finally"
                        );
                      if (this.prev < i.finallyLoc) return r(i.finallyLoc);
                    }
                  }
                }
              },
              abrupt: function (t, e) {
                for (var r = this.tryEntries.length - 1; r >= 0; --r) {
                  var o = this.tryEntries[r];
                  if (
                    o.tryLoc <= this.prev &&
                    n.call(o, "finallyLoc") &&
                    this.prev < o.finallyLoc
                  ) {
                    var i = o;
                    break;
                  }
                }
                i &&
                  ("break" === t || "continue" === t) &&
                  i.tryLoc <= e &&
                  e <= i.finallyLoc &&
                  (i = null);
                var c = i ? i.completion : {};
                return (
                  (c.type = t),
                  (c.arg = e),
                  i
                    ? ((this.method = "next"), (this.next = i.finallyLoc), h)
                    : this.complete(c)
                );
              },
              complete: function (t, e) {
                if ("throw" === t.type) throw t.arg;
                return (
                  "break" === t.type || "continue" === t.type
                    ? (this.next = t.arg)
                    : "return" === t.type
                    ? ((this.rval = this.arg = t.arg),
                      (this.method = "return"),
                      (this.next = "end"))
                    : "normal" === t.type && e && (this.next = e),
                  h
                );
              },
              finish: function (t) {
                for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                  var r = this.tryEntries[e];
                  if (r.finallyLoc === t)
                    return this.complete(r.completion, r.afterLoc), q(r), h;
                }
              },
              catch: function (t) {
                for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                  var r = this.tryEntries[e];
                  if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                      var o = n.arg;
                      q(r);
                    }
                    return o;
                  }
                }
                throw new Error("illegal catch attempt");
              },
              delegateYield: function (t, e, r) {
                return (
                  (this.delegate = {
                    iterator: k(t),
                    resultName: e,
                    nextLoc: r,
                  }),
                  "next" === this.method && (this.arg = void 0),
                  h
                );
              },
            }),
            e
          );
        }
        function l(t, e, r, n, o, i, c) {
          try {
            var a = t[i](c),
              u = a.value;
          } catch (l) {
            return void r(l);
          }
          a.done ? e(u) : Promise.resolve(u).then(n, o);
        }
        function s(t) {
          return function () {
            var e = this,
              r = arguments;
            return new Promise(function (n, o) {
              var i = t.apply(e, r);
              function c(t) {
                l(i, n, o, c, a, "next", t);
              }
              function a(t) {
                l(i, n, o, c, a, "throw", t);
              }
              c(void 0);
            });
          };
        }
        var f = document.querySelector,
          d = document.querySelectorAll;
        document.addEventListener("DOMContentLoaded", function () {
          function t(t) {
            t.forEach(function (t) {
              if ("USD" != t.getAttribute("data-currency")) {
                var e = t.textContent
                  .replace(/[^0-9.,]/g, "")
                  .replace(/,/g, ".");
                function r() {
                  return (r = s(
                    u().mark(function e(r, n, o) {
                      var i, c, a, l, s;
                      return u().wrap(function (e) {
                        for (;;)
                          switch ((e.prev = e.next)) {
                            case 0:
                              return (
                                (e.next = 2),
                                fetch(
                                  "https://api.frankfurter.dev/v1/latest?base="
                                    .concat(r, "&symbols=")
                                    .concat(n)
                                )
                              );
                            case 2:
                              return (i = e.sent), (e.next = 5), i.json();
                            case 5:
                              (c = e.sent),
                                (a = o * c.rates[n]),
                                (l = new Intl.NumberFormat(void 0, {
                                  style: "currency",
                                  currency: n,
                                }).format(a)),
                                (s = l.split(" ")),
                                (t.textContent = s[1] + s[0]);
                            case 10:
                            case "end":
                              return e.stop();
                          }
                      }, e);
                    })
                  )).apply(this, arguments);
                }
                !(function (t, e, n) {
                  r.apply(this, arguments);
                })("USD", t.getAttribute("data-currency"), e);
              }
            });
          }
          function r(t) {
            var e = document.createElement("div"),
              r = document.createElement("p"),
              n = t.querySelector(".product-description__text"),
              o = parseInt(n.getAttribute("data-line-clamp"));
            n.classList.remove("line-clamp");
            var c = (function (t) {
              for (
                var e = 0,
                  r = new Set(),
                  n = document.createTreeWalker(t, NodeFilter.SHOW_TEXT, {
                    acceptNode: function (t) {
                      return t.textContent.trim()
                        ? NodeFilter.FILTER_ACCEPT
                        : NodeFilter.FILTER_REJECT;
                    },
                  });
                n.nextNode();

              ) {
                var o = n.currentNode,
                  c = document.createRange();
                c.selectNodeContents(o);
                var a,
                  u = i(c.getClientRects());
                try {
                  for (u.s(); !(a = u.n()).done; ) {
                    var l = a.value,
                      s = Math.round(l.top);
                    !r.has(s) && l.width > 0 && (r.add(s), e++);
                  }
                } catch (f) {
                  u.e(f);
                } finally {
                  u.f();
                }
              }
              return e;
            })(n);
            n.classList.add("line-clamp"),
              c < o ||
                ((r.innerHTML = "See more ↓"),
                r.classList.add("product-description__see-more"),
                r.addEventListener("click", function () {
                  n.classList.toggle("line-clamp"),
                    (r.textContent =
                      "See more ↓" === r.textContent
                        ? "See less ↑"
                        : "See more ↓");
                }),
                e.appendChild(r),
                t.appendChild(e));
          }
          try {
            new Swiper(".product-previous-slider", {
              slidesPerView: 2,
              loop: !0,
              grabCursor: !0,
              pagination: { el: ".swiper-pagination", clickable: !0 },
              breakpoints: {
                480: { slidesPerView: 3 },
                768: { slidesPerView: 4 },
                1024: { slidesPerView: 5 },
              },
            }),
              (function () {
                var t = document.querySelector(".product-gallery"),
                  e = t.querySelector(".product-gallery__thumbnail"),
                  r = e.querySelector("img"),
                  n = t.querySelectorAll(".product-gallery__item");
                e.addEventListener("mousemove", function (t) {
                  var n = e.getBoundingClientRect(),
                    o = ((t.clientX - n.left) / n.width) * 100,
                    i = ((t.clientY - n.top) / n.height) * 100;
                  (r.style.transformOrigin = "".concat(o, "% ").concat(i, "%")),
                    (r.style.transform = "scale(2)");
                }),
                  e.addEventListener("mouseleave", function () {
                    r.style.transform = "scale(1)";
                  });
                var o = t.querySelector(".js-active")
                  ? t.querySelector(".js-active")
                  : null;
                n.forEach(function (e) {
                  e.addEventListener("click", function () {
                    o && o.classList.remove("js-active"),
                      (o = this),
                      e.classList.toggle("js-active"),
                      (t.querySelector(".product-gallery__thumbnail img").src =
                        this.querySelector("img").src);
                  });
                });
              })(),
              document.querySelectorAll(".product-block").forEach(function (n) {
                switch (!0) {
                  case n.classList.contains("product-accordion-block"):
                    n.querySelectorAll(".product-accordion").forEach(function (
                      t
                    ) {
                      var e = t.querySelector(".heading"),
                        r = t.querySelector(".content");
                      e.addEventListener("click", function () {
                        t.classList.contains("js-active")
                          ? ((r.style.height = r.scrollHeight + "px"),
                            requestAnimationFrame(function () {
                              r.style.height = "0px";
                            }),
                            t.classList.remove("js-active"))
                          : ((r.style.height = r.scrollHeight + "px"),
                            r.addEventListener(
                              "transitionend",
                              function () {
                                r.style.height = "auto";
                              },
                              { once: !0 }
                            ),
                            t.classList.add("js-active"));
                      });
                      var n = new MutationObserver(function () {
                        var e = t.querySelector(".yotpo-widget-instance");
                        if (e) {
                          var r = e.querySelector("button");
                          if (r) {
                            var o = r.cloneNode(!0);
                            r.replaceWith(o), n.disconnect();
                          }
                        }
                      });
                      n.observe(t, { childList: !0, subtree: !0 });
                    });
                    break;
                  case n.classList.contains("product-subscription"):
                  case n.classList.contains("product-price"):
                    !(function (e) {
                      t(e.querySelectorAll(".product__price-cross"));
                    })(n);
                    break;
                  case n.classList.contains("product-reviews"):
                    !(function (t) {
                      var r = new MutationObserver(function () {
                        var n = t.querySelector(".yotpo-widget-instance");
                        if (n) {
                          var o = n.querySelector(".yotpo-widget-clear");
                          o &&
                            (o.addEventListener("click", function () {
                              var t,
                                r = e(
                                  document.querySelectorAll(
                                    ".product-accordion-block .product-accordion"
                                  )
                                ).find(function (t) {
                                  return t.querySelector(
                                    ".yotpo-reviews-main-widget"
                                  );
                                });
                              r &&
                                !r.classList.contains("js-active") &&
                                (null === (t = r.querySelector("button")) ||
                                  void 0 === t ||
                                  t.click());
                            }),
                            r.disconnect());
                        }
                      });
                      r.observe(t, { childList: !0, subtree: !0 });
                    })(n);
                    break;
                  case n.classList.contains("product-description"):
                    r(n);
                }
              });
            var n = window.innerWidth;
            window.addEventListener("resize", function () {
              window.innerWidth !== n &&
                ((n = window.innerWidth),
                document
                  .querySelectorAll(".product-description__see-more")
                  .forEach(function (t) {
                    var e;
                    null === (e = t.closest("div")) ||
                      void 0 === e ||
                      e.remove();
                  }),
                document
                  .querySelectorAll(".product-description")
                  .forEach(function (t) {
                    r(t);
                  }));
            }),
              (document.querySelector("[data-v-714fdf43] span").innerHTML =
                "Is this a gift? Write a note here");
          } catch (o) {
            console.log(o);
          }
        });
      },
      {},
    ],
  },
  {},
  ["Focm"],
  null
);
